import { render, staticRenderFns } from "./ReSearchFlatBig.vue?vue&type=template&id=47bd6ef4&scoped=true"
import script from "./ReSearchFlatBig.vue?vue&type=script&lang=js"
export * from "./ReSearchFlatBig.vue?vue&type=script&lang=js"
import style0 from "./ReSearchFlatBig.vue?vue&type=style&index=0&id=47bd6ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bd6ef4",
  null
  
)

export default component.exports